var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.laptops),function(laptop){return _c('li',{key:laptop.id},[_vm._v("https://ultrashop.uz/"+_vm._s(laptop.brand.slug + '/' + laptop.slug + '/' + laptop.id))])}))])}
var staticRenderFns = []

export { render, staticRenderFns }